import { AxiosRequestConfig } from 'axios';
import { getContentApiScope } from './ContentModeContext';

const LECTURE_COURSE_ROUTES: Record<string, string> = {
	'course/students': 'standalone-courses/lectures/students',
	'course/enroll': 'standalone-courses/lectures/enroll',
	'course/unenroll': 'standalone-courses/lectures/unenroll',
	'course/enrollment/update': 'standalone-courses/lectures/enrollment/update',
};

const STANDALONE_RESOURCES = [
	'enrollment/course/',
	'progress/course',
	'reports/course',
	'clone/',
	'units/',
	'document/',
	'video/',
	'video-import/',
	'webContent/',
	'test/',
	'webinar/',
	'assignment/',
];

export const routeContentRequest = (config: AxiosRequestConfig) => {
	const scope = getContentApiScope();
	if (
		scope.mode !== 'standalone-lecture' ||
		!config.url ||
		config.url.startsWith('standalone-courses/lectures/')
	) {
		return config;
	}

	config.url = config.url.replace(/^\/+/, '');
	if (
		config.data &&
		typeof config.data === 'object' &&
		!(config.data instanceof FormData)
	) {
		config.data = {
			...config.data,
			standalone_lecture_id: scope.lectureId,
		};
	}

	// longest prefix first: 'course/enrollment/update' must win over
	// 'course/enroll' (insertion order made the shorter key match first)
	const matchingCourseRoute = Object.keys(LECTURE_COURSE_ROUTES)
		.sort((a, b) => b.length - a.length)
		.find((route) => config.url?.startsWith(route));
	if (matchingCourseRoute) {
		config.url = config.url.replace(
			matchingCourseRoute,
			LECTURE_COURSE_ROUTES[matchingCourseRoute]
		);
		return config;
	}

	if (STANDALONE_RESOURCES.some((resource) => config.url?.startsWith(resource))) {
		config.url = `standalone-courses/lectures/${config.url}`;
	}
	return config;
};
